<template lang="html">
<svg xmlns="http://www.w3.org/2000/svg" width="13.158" height="6.775" viewBox="0 0 13.158 6.775">
  <g id="streamline-icon-school-book_140x140" data-name="streamline-icon-school-book@140x140" transform="translate(0.5 0.5)">
    <path id="Path_44750" data-name="Path 44750" class="cls-1" d="M30.625,36.335V31.767a1.142,1.142,0,1,1,2.284,0v4.568" transform="translate(-30.625 -30.625)"/>
    <path id="Path_44751" data-name="Path 44751" class="cls-1" d="M30.625,56.875h2.284" transform="translate(-30.625 -53.449)"/>
    <path id="Path_44752" data-name="Path 44752" class="cls-1" d="M74.375,53.835v-5.71" transform="translate(-69.438 -48.06)"/>
    <path id="Path_44753" data-name="Path 44753" class="cls-1" d="M74.375,48.125h1.142a1.142,1.142,0,0,1,1.142,1.142v.571a1.142,1.142,0,0,1-1.142,1.142H74.375" transform="translate(-69.438 -48.06)"/>
    <path id="Path_44754" data-name="Path 44754" class="cls-1" d="M74.375,70h1.142a1.142,1.142,0,0,1,1.142,1.142v.571a1.142,1.142,0,0,1-1.142,1.142H74.375" transform="translate(-69.438 -67.08)"/>
    <path id="Path_44755" data-name="Path 44755" class="cls-1" d="M120.409,30.625a2.284,2.284,0,0,0-2.284,2.284v1.142a2.284,2.284,0,0,0,2.284,2.284" transform="translate(-108.251 -30.625)"/>
  </g>
</svg>

</template>

<script>
export default {
  name: 'IconSalesWordCategory',
};
</script>
<style lang="scss" scoped>
.cls-1 {
    fill: none;
    stroke: #fa0;
    stroke-linecap: round;
    stroke-linejoin: round;
}

</style>


